import React, { useEffect } from 'react';

const Datenschutz = () => {
  const BLACK = '#0a0a0a';
  const WHITE = '#ffffff';
  const YELLOW = '#ffd700';

  // ---- TikTok Pixel Code ----
  useEffect(() => {
    // Check if TikTok pixel is already loaded
    if (window.ttq) return;

    const t = 'ttq';
    window.TiktokAnalyticsObject = t;
    const ttq = window[t] = window[t] || [];
    
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
    
    ttq.setAndDefer = function (target, method) {
      target[method] = function () {
        target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    
    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    
    ttq.instance = function (id) {
      const instance = ttq._i[id] || [];
      for (let n = 0; n < ttq.methods.length; n++) {
        ttq.setAndDefer(instance, ttq.methods[n]);
      }
      return instance;
    };
    
    ttq.load = function (pixelId, options) {
      const scriptUrl = "https://analytics.tiktok.com/i18n/pixel/events.js";
      ttq._i = ttq._i || {};
      ttq._i[pixelId] = [];
      ttq._i[pixelId]._u = scriptUrl;
      ttq._t = ttq._t || {};
      ttq._t[pixelId] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[pixelId] = options || {};
      
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = scriptUrl + "?sdkid=" + pixelId + "&lib=" + t;
      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    };

    ttq.load('D4E3333C77UF4SPAJ6OG');
    ttq.page();
  }, []);

  return (
    <div style={{ backgroundColor: WHITE, minHeight: '100vh' }}>
      {/* Header Section */}
      <div style={{
        backgroundColor: BLACK,
        color: WHITE,
        padding: '180px 40px 120px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '3.5rem',
          fontWeight: '900',
          marginBottom: '20px',
          letterSpacing: '-1px'
        }}>
          Daten<span style={{ color: YELLOW }}>schutz</span>
        </h1>
        <p style={{
          fontSize: '1.2rem',
          color: 'rgba(255,255,255,0.7)',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          Datenschutzerklärung für Auto Hobby Werkstatt
        </p>
      </div>

      {/* Content Section */}
      <div style={{
        maxWidth: '1000px',
        margin: '0 auto',
        padding: '80px 40px',
        color: BLACK
      }}>
        
        {/* Allgemeine Hinweise */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Allgemeine Hinweise
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen entnehmen Sie bitte der nachstehenden Datenschutzerklärung.
          </p>
        </section>

        {/* Datenerfassung */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Datenerfassung auf dieser Website
          </h2>
          
          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: '600',
            marginBottom: '15px',
            color: BLACK,
            marginTop: '30px'
          }}>
            Wer ist verantwortlich für die Datenerfassung auf dieser Website?
          </h3>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Die Datenverarbeitung erfolgt durch den Websitebetreiber. Die Kontaktdaten finden Sie im Impressum dieser Website.
          </p>

          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: '600',
            marginBottom: '15px',
            color: BLACK,
            marginTop: '30px'
          }}>
            Wie erfassen wir Ihre Daten?
          </h3>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen, etwa indem Sie ein Kontaktformular ausfüllen. Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
          </p>

          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: '600',
            marginBottom: '15px',
            color: BLACK,
            marginTop: '30px'
          }}>
            Wofür nutzen wir Ihre Daten?
          </h3>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
          </p>

          <h3 style={{
            fontSize: '1.3rem',
            fontWeight: '600',
            marginBottom: '15px',
            color: BLACK,
            marginTop: '30px'
          }}>
            Welche Rechte haben Sie bezüglich Ihrer Daten?
          </h3>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten. Sie haben außerdem das Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden (Kontaktdaten siehe Impressum). Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Weitere Informationen finden Sie in den nachfolgenden Abschnitten.
          </p>
        </section>

        {/* Datenschutz */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Datenschutz
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>
        </section>

        {/* Verantwortliche Stelle */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Hinweis zur verantwortlichen Stelle
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          </p>
          <div style={{
            backgroundColor: '#f8f8f8',
            padding: '30px',
            borderLeft: `4px solid ${YELLOW}`,
            marginBottom: '20px'
          }}>
            <p style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '10px', color: BLACK }}>
              Nadeem Choudhary
            </p>
            <p style={{ fontSize: '1rem', marginBottom: '5px', color: '#333' }}>
              Auto Hobby Werkstatt
            </p>
            <p style={{ fontSize: '1rem', marginBottom: '5px', color: '#333' }}>
              Küvenkamp 3
            </p>
            <p style={{ fontSize: '1rem', marginBottom: '15px', color: '#333' }}>
              46509 Xanten
            </p>
            <p style={{ fontSize: '1rem', marginBottom: '5px', color: '#333' }}>
              Telefon: +49 15560524486
            </p>
            <p style={{ fontSize: '1rem', marginBottom: '0', color: '#333' }}>
              E-Mail: <a href="mailto:info@autoshobbywerkstatt.de" style={{ color: YELLOW, textDecoration: 'none' }}>
                info@autoshobbywerkstatt.de
              </a>
            </p>
          </div>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet.
          </p>
        </section>

        {/* Widerruf der Einwilligung */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Widerruf Ihrer Einwilligung zur Datenverarbeitung
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>
        </section>

        {/* Widerspruchsrecht */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, haben Sie jederzeit das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Wenn Sie Widerspruch einlegen, werden Ihre betroffenen personenbezogenen Daten nicht mehr verarbeitet, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Werden Ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, so haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.
          </p>
        </section>

        {/* Beschwerderecht */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Beschwerderecht bei der zuständigen Aufsichtsbehörde
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Im Falle von Verstößen gegen die DSGVO steht Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde zu.
          </p>
        </section>

        {/* Datenübertragbarkeit */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Recht auf Datenübertragbarkeit
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen.
          </p>
        </section>

        {/* SSL/TLS Verschlüsselung */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            SSL- bzw. TLS-Verschlüsselung
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
          </p>
        </section>

        {/* Auskunft, Löschung, Berichtigung */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Auskunft, Löschung und Berichtigung
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten.
          </p>
        </section>

        {/* Einschränkung der Verarbeitung */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Recht auf Einschränkung der Verarbeitung
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Das Recht auf Einschränkung der Verarbeitung besteht in folgenden Fällen:
          </p>
          <ul style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            marginLeft: '30px',
            color: '#333'
          }}>
            <li style={{ marginBottom: '15px' }}>
              Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </li>
            <li style={{ marginBottom: '15px' }}>
              Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig geschah/geschieht, können Sie statt der Löschung die Einschränkung der Datenverarbeitung verlangen.
            </li>
            <li style={{ marginBottom: '15px' }}>
              Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen, haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </li>
            <li style={{ marginBottom: '15px' }}>
              Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </li>
          </ul>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines Mitgliedstaats verarbeitet werden.
          </p>
        </section>

        {/* Widerspruch gegen Werbe-E-Mails */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Widerspruch gegen Werbe-E-Mails
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen.
          </p>
        </section>

        {/* Hosting */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Hosting
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Diese Website wird bei einem externen Dienstleister gehostet. Personenbezogene Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots.
          </p>
        </section>

        {/* Cookies */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Cookies
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Unsere Internetseiten verwenden teilweise sogenannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Die meisten der von uns verwendeten Cookies sind sogenannte „Session-Cookies". Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter Funktionen erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. Soweit andere Cookies (z. B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser Datenschutzerklärung gesondert behandelt.
          </p>
        </section>

        {/* Server-Log-Dateien */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Server-Log-Dateien
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
          </p>
          <ul style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            marginLeft: '30px',
            color: '#333'
          }}>
            <li>Browsertyp und Browserversion</li>
            <li>verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
          </p>
        </section>

        {/* Anfrage per E-Mail, Telefon oder Telefax */}
        <section style={{ marginBottom: '50px' }}>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            marginBottom: '25px',
            color: BLACK,
            borderLeft: `4px solid ${YELLOW}`,
            paddingLeft: '20px'
          }}>
            Anfrage per E-Mail, Telefon oder Telefax
          </h2>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>
          <p style={{
            fontSize: '1rem',
            lineHeight: '1.8',
            marginBottom: '20px',
            color: '#333'
          }}>
            Die von Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt. Zwingende gesetzliche Bestimmungen bleiben unberührt.
          </p>
        </section>

        {/* Stand */}
        <div style={{
          marginTop: '60px',
          paddingTop: '30px',
          borderTop: `2px solid ${YELLOW}`,
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '0.95rem',
            color: '#666',
            fontWeight: '600'
          }}>
            Stand: {new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })}
          </p>
          <p style={{
            fontSize: '1.1rem',
            color: BLACK,
            marginTop: '15px',
            fontWeight: '600'
          }}>
            Auto Hobby Werkstatt – Ihr Partner für professionelle Kfz-Werkstattlösungen
          </p>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;